export default "__VITE_ASSET__aQ6KAOK6__"